import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY, SERVICES } from '../data/company';

export function Footer() {
  return (
    <footer className="bg-forest text-white pt-16 pb-12 border-t-4 border-copper">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          
          {/* Col 1: Firm Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-copper text-white rounded-lg flex items-center justify-center font-bold text-lg shadow-sm overflow-hidden border border-white/20">
                {COMPANY.logoImage ? (
                  <img 
                    src={`https://assets.auxodev.dk/cdn-cgi/image/width=100,quality=90,format=auto/${COMPANY.logoImage.replace('https://assets.auxodev.dk/', '')}`} 
                    alt={COMPANY.name} 
                    className="w-full h-full object-cover object-center"
                  />
                ) : (
                  <i className="fa-solid fa-screwdriver-wrench text-white" aria-hidden="true" />
                )}
              </div>
              <span className="font-bold text-xl tracking-tight">
                {COMPANY.name}
              </span>
            </div>
            <p className="text-sand/80 text-sm leading-relaxed">
              Din pålidelige lokale altmuligmand i Juelsminde og omegn. Professionel og effektiv service med fokus på kvalitet og god dialog.
            </p>
            <div className="pt-2 text-xs text-sand/60">
              CVR: <span className="whitespace-nowrap font-medium text-sand">{COMPANY.cvr}</span>
            </div>
          </div>

          {/* Col 2: Services */}
          <div>
            <h3 className="text-white font-bold text-base mb-4 uppercase tracking-wider">
              Ydelser
            </h3>
            <ul className="space-y-2.5 text-sm text-sand/80">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link 
                    to={`/ydelser/${s.slug}`}
                    className="hover:text-white transition-colors flex items-center gap-2"
                  >
                    <i className="fa-solid fa-chevron-right text-[10px] text-white/80" aria-hidden="true" />
                    <span>{s.title}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Navigation */}
          <div>
            <h3 className="text-white font-bold text-base mb-4 uppercase tracking-wider">
              Navigation
            </h3>
            <ul className="space-y-2.5 text-sm text-sand/80">
              <li>
                <Link to="/" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/80" aria-hidden="true" />
                  <span>Forside</span>
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/80" aria-hidden="true" />
                  <span>Om Altmuligmanden</span>
                </Link>
              </li>
              <li>
                <Link to="/ydelser" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/80" aria-hidden="true" />
                  <span>Alle ydelser</span>
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/80" aria-hidden="true" />
                  <span>Galleri</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-white transition-colors flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/80" aria-hidden="true" />
                  <span>Kontakt</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact Info */}
          <div>
            <h3 className="text-white font-bold text-base mb-4 uppercase tracking-wider">
              Kontakt os
            </h3>
            <div className="space-y-3.5 text-sm text-sand/90">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-white mt-1" aria-hidden="true" />
                <span>{COMPANY.address}</span>
              </div>
              
              <div className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-white" aria-hidden="true" />
                <a 
                  href={`tel:${COMPANY.phone}`}
                  className="hover:text-white transition-colors whitespace-nowrap font-semibold"
                >
                  {COMPANY.phoneFormatted}
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-white" aria-hidden="true" />
                <a 
                  href={`mailto:${COMPANY.email}`}
                  className="hover:text-white transition-colors whitespace-nowrap"
                >
                  {COMPANY.email}
                </a>
              </div>

              <div className="pt-2">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 bg-copper hover:bg-copper-hover text-white font-semibold px-4 py-2 rounded-lg text-xs tracking-wide transition-colors"
                >
                  <i className="fa-solid fa-paper-plane" aria-hidden="true" />
                  <span>Send en besked</span>
                </Link>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center text-xs text-sand/60 gap-4">
          <p>© {new Date().getFullYear()} {COMPANY.name}. Alle rettigheder forbeholdes.</p>
          <p>Lokal håndværkshjælp i Juelsminde, Barrit, Stouby, Glud, Klakring & Hedensted kommune.</p>
        </div>
      </div>
    </footer>
  );
}
